module.exports = __webpack_public_path__ + "img/Mukoleks_Gray_1280x1010.919dad57.jpg";